import { Axis } from "@visx/axis";
import { useTheme } from "@mui/material";
import useAreaChart from "../AreaChartProvider/useAreaChartStore";
import useXAxis from "../XAxisProvider/useXAxisStore/useXAxisStore";
import useXAxisActions from "../XAxisProvider/useXAxisActions";

function XAxis() {
  const theme = useTheme();
  const { height, margin } = useAreaChart();
  const { xAxis } = useXAxis();
  const { getXScale } = useXAxisActions();

  const scale = getXScale();

  return (
    <Axis
      orientation={xAxis.orientation}
      top={height - margin.bottom}
      scale={scale}
      tickFormat={(d) => xAxis.tickFormat(d as Date)}
      stroke={theme.palette.grey[20]}
      tickLabelProps={{
        fill: theme.palette.grey[100],
        fontSize: 12,
        lineHeight: "18px",
        textAnchor: "middle",
        alignmentBaseline: "middle",
        dominantBaseline: "middle",
      }}
      numTicks={xAxis.numTicks}
      hideTicks={xAxis.disableTicks}
    />
  );
}

export default XAxis;
